<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
    extends: CoreComponent,

    data() {
        return {
            stime: null,
            etime: null,
            thead: null,
            tbody: null,
            loader: null,
            errorMessage: null,
            loadButton: null,
            downloadButton: null,
            stimeInput: null,
            etimeInput: null,
            jsonData: null
        };
    },

    methods: {

        resetTable() {
            this.thead.innerHTML = '';
            this.tbody.innerHTML = '';
        },

        showLoader() {
            this.loadButton.disabled = true;
            this.downloadButton.disabled = true;
            this.loader.classList.add("cmp-air-quality-monitor__loader--visible");
        },

        hideLoader() {
            this.loadButton.disabled = false;
            this.downloadButton.disabled = false;
            this.loader.classList.remove("cmp-air-quality-monitor__loader--visible");
            
        },

        showError() {
            this.errorMessage.classList.add("cmp-air-quality-monitor__error--visible");
        },

        hideError() {
            this.errorMessage.classList.remove("cmp-air-quality-monitor__error--visible");
        },

        downloadCSV() {
            if (!this.jsonData.length) return;

            const headers = Object.keys(this.jsonData[0]);

            const csv = [
                headers.join(","),
                ...this.jsonData.map(row => {
                    return headers.map(header => {
                        const value = row[header] ?? "";
                        return `"${String(value).replace(/"/g, '""')}"`;
                    }).join(",");
                })
            ].join("\n");

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "export.csv";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(link.href);
        },  

        renderTable() {
            if (!this.jsonData || !this.jsonData.length) {
                return;
            }

            const keys = Object.keys(this.jsonData[0]);
            let theadHTML = '';
            keys.forEach(key => {
                theadHTML += `<th>${key}</th>`;
            })
            this.thead.innerHTML = theadHTML;
            
            this.tbody.innerHTML = '';
            this.jsonData.forEach(item => {
                let row = document.createElement("tr");
                keys.forEach(key => {
                    let cell = document.createElement("td");
                    cell.textContent = item[key] || '---'
                    row.appendChild(cell);
                })
                this.tbody.appendChild(row);
            });

        },

        async loadData() {

            this.hideError();
            this.showLoader();
            this.resetTable();

            try {
                let response = await fetch(
                    `.dow.air.quality.monitor.json?stime=${this.stime}&etime=${this.etime}`,
                    {
                        method: 'GET'
                    }
                );

                if (!response.ok) {
                    throw new Error(`Air Quality Fetch Failed: ${response.status}`);
                }

                this.jsonData = await response.json();
                                
                this.renderTable();
                this.hideLoader();
                

            } catch (error) {
                this.hideLoader();
                this.showError();
                console.error('Error fetching data:', error);
            }
        }
    },

    mounted() {

        this.thead = this.cmpEl.querySelector("thead");
        this.tbody = this.cmpEl.querySelector("tbody");
        this.loader = this.cmpEl.querySelector(".cmp-air-quality-monitor__loader");
        this.errorMessage = this.cmpEl.querySelector(".cmp-air-quality-monitor__error");
        this.loadButton = this.cmpEl.querySelector(".cmp-air-quality-monitor__load-button"); 
        this.downloadButton = this.cmpEl.querySelector(".cmp-air-quality-monitor__download-button");
        this.stimeInput = this.cmpEl.querySelector("#aq-stime");
        this.etimeInput = this.cmpEl.querySelector("#aq-etime");

        let now = new Date();
        this.etime = now.toISOString();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        this.etimeInput.value = now.toISOString().slice(0,16);

        let startDate = new Date(now.getTime() - ( 14*24*60*60*1000 ));
        this.stime = startDate.toISOString();
        startDate.setMinutes(startDate.getMinutes() - startDate.getTimezoneOffset());
        this.stimeInput.value = startDate.toISOString().slice(0,16);

        this.loadData();

        this.downloadButton.addEventListener("click", e => {
            this.downloadCSV();
        });

        this.loadButton.addEventListener("click", e => {
            this.loadData();
        })

        this.stimeInput.addEventListener("change", e => {
            this.stime = new Date(this.stimeInput.value).toISOString();
        });

        this.etimeInput.addEventListener("change", e => {
            this.etime = new Date(this.etimeInput.value).toISOString();
        });

    }
}

</script>

<style lang="scss">
@import './air-quality-monitor.scss';
</style>
